import type { BadgeTone } from '@shared/ui';

import type { ClientSummary } from '../schemas/client';

/**
 * The one badge a client gets, and which fact wins when two apply.
 *
 * A status other than `active` wins over the sandbox mark: an archived sandbox
 * is archived first. Showing "Sandbox" there hid the only fact that says the
 * client is no longer in use, and an inactive client in the active (green)
 * tone read as healthy.
 */
export function clientStatusBadge(client: Pick<ClientSummary, 'isSandbox' | 'status'>): {
    label: string;
    tone: BadgeTone;
} {
    if (client.status !== 'active') return { label: client.status, tone: 'neutral' };
    if (client.isSandbox === true) return { label: 'Sandbox', tone: 'warning' };
    return { label: client.status, tone: 'active' };
}
